import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {fetchAvailableParticipants, fetchChatAvailableParticipants} from '../services/chats';
import {fetchClaimColleagues} from "../services/travelClaims";

export const useAvailableParticipantsQuery = (chatId: string | undefined) => {
    if (!chatId) {
        throw Error("Отсутствует идентификатор чата");
    }

    return useQuery({
        queryFn: () => fetchAvailableParticipants(chatId),
        queryKey: ['chat', chatId],
        staleTime: 1000 * 5,
    });
};

export const useChatAvailableParticipantsQuery = (search: string | undefined, chatId: string) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['chatAvailableParticipants'],
        staleTime: 1000 * 5, // TODO
        queryFn: (
            {
                pageParam = {
                    limit: limit,
                    offset: 0
                }
            }
        ) => fetchChatAvailableParticipants(chatId, pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}